import React, { createContext } from "react";
import { Dialog as GenericDialog, GenericDialogProps } from "../../dialog";
import { Button } from "../../../components/formInputs";
import { PolicyContextProvider } from "./PolicyContext";
import { createStyles, Grid, makeStyles } from "@material-ui/core";
import ApproveBankPopUpContent from "./ApproveBankContent";
import PaymentMethodRejectionPopup from "./PaymentMethodRejectionPopup";

export interface ApproveBankPopUpProps {
    setOpenPopup: Function,
    openPopup: boolean,
    enrollmentId?: string
    client?: any
    refreshList?: Function,
    clientPolicy?: any,
    bankHolderName?: string,
    actionPayload?: string,
    isRejected?: boolean,
    setIsRejected?: Function,
    setPaymentMethodReject?: Function
    approve?: boolean,
    formValues?: any,
    setIsApproved?: Function
}

export const ApproveBankPopUpContext = createContext<{
    client?: any,
    bankHolderName?: string,
    enrollmentId?: string,
    setOpenPopup: Function
    refreshList?: Function,
    setSubmitting?: Function,
    clientPolicy?: any
    actionPayload?: string,
    commentDialogProps?: any
}>({ setOpenPopup: Function })

export default function ApproveBankPopup(props: ApproveBankPopUpProps) {
    const {
        openPopup,
        setOpenPopup,
        client,
        enrollmentId,
        refreshList,
        clientPolicy,
        bankHolderName,
        actionPayload
    } = props;
    const [paymentMethodReject, setPaymentMethodReject] = React.useState(false);
    const [submitting, setSubmitting] = React.useState(false);
    const [isRejected, setIsRejected] = React.useState(false);
    const [approve, setIsApprove] = React.useState(false);
    const [formValues, setFormVlaues] = React.useState({});
    const handleClose = () => {
        setOpenPopup(false);
    };

    const useStyles = makeStyles(() =>
        createStyles(
            {
                buttonFormatting: {
                    display: "flex",
                    gap: "2px"
                }
            }
        )
    )

    const classes = useStyles();

    const dialogProps: GenericDialogProps = {

        actions: (
            <Grid className={classes.buttonFormatting}>

                <Button
                    label={"Reject"}
                    type="button"
                    variant="contained"
                    color="primary"
                    onClick={() => {
                        setPaymentMethodReject(true);
                    }}
                    disabled={submitting}
                    className="btnContainedRed"
                />
                <Button
                    label={"Approve"}
                    type="submit"
                    variant="contained"
                    form={"ApprovePaymentMethod"}
                    disabled={submitting}
                    onClick={() => {
                        setIsApprove(true);
                        if (approve) {
                            setOpenPopup(false);
                        }
                    }}
                    color="primary"
                    className="floatLeft floatRightSM mb15"
                />
            </Grid>
        ),
        "aria-labelledby": "upload_proposal-pop-up-form-dialog-title",
        fullWidth: true,
        maxWidth: "md",
        content: (<PolicyContextProvider clientData={{
            name: client.user.firstName + " " + client.user.lastName,
            email: client.user.email,
            clientPolicy: clientPolicy,
            ...client,
        }}>
            <ApproveBankPopUpContext.Provider
                value={{
                    client,
                    enrollmentId,
                    setOpenPopup,
                    refreshList,
                    setSubmitting,
                    clientPolicy,
                    bankHolderName,
                    actionPayload,
                }}>
                <ApproveBankPopUpContent setIsRejected={setIsRejected} setIsApproved={setIsApprove}
                    formValues={formValues} approve={approve}
                    setPaymentMethodReject={setPaymentMethodReject} isRejected={isRejected}>
                    {
                        paymentMethodReject && <PaymentMethodRejectionPopup
                            setPaymentMethodReject={setPaymentMethodReject}
                            setIsRejected={setIsRejected}
                            formValues={formValues}
                            setOpenPopup={setOpenPopup}
                            openPopup={openPopup}
                            setSubmitting={setSubmitting}
                        />

                    }
                </ApproveBankPopUpContent>
            </ApproveBankPopUpContext.Provider>
        </PolicyContextProvider>),
        dividers: true,
        onClose: handleClose,
        open: openPopup,
        title: "Bank Details",
    };


    return (
        <>
            {
                openPopup &&
                <GenericDialog {...dialogProps} />
            }

        </>
    );
};








